<!-- member-list-dialog.component.html -->
<p-dialog [(visible)]="visible"
          [modal]="true"
          [style]="{'width': '90vw', 'max-width': '1200px'}"
          [draggable]="false"
          [resizable]="false"
          [closable]="false"
          (onHide)="onHide()"
          [header]="membersLabel + ' and ' + childrenLabel">

    <p-table [value]="members" [columns]="cols" [tableStyle]="{'min-width': '50rem'}" [expandedRowKeys]="expandedRowKeys" dataKey="Id"
             [sortField]="sortField"
             [sortOrder]="sortOrder"
             (onSort)="onSort($event)">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 2rem"></th>
                <th *ngFor="let col of cols" [pSortableColumn]="col.field">
                    {{col.header}}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-member let-expanded="expanded">
            <tr>
                <td>
                    <button type="button" pButton pRipple
                            class="p-button-text p-button-rounded p-button-plain"
                            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                            (click)="toggleRow(member)"
                            *ngIf="hasChildren(member)">
                    </button>
                </td>
                <td>{{member.FirstName}}</td>
                <td>{{member.LastName}}</td>
                <td>{{member.PhoneNumber}}</td>
                <td>{{member.Email}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-member>
            <tr>
                <td colspan="3">
                    <div class="children-table-container">
                        <p-table [value]="member.Children">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Child Name</th>
                                    <th>Date-of-Birth</th>
                                    <!-- Add more child-specific columns as needed -->
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-child>
                                <tr>
                                    <td>{{child.FirstName}} {{child.LastName}}</td>
                                    <td>{{child.BirthDate | date:'MMM d, y'}}</td>
                                    <!-- Add more child-specific data as needed -->
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="Close" icon="pi pi-times"
                class="p-button-outlined" (click)="onHide()">
        </button>
    </ng-template>
</p-dialog>
